import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Contact.css';
import ContactForm from '../../components/ContactForm';

const Contact = ({ reCaptcha }) => (
  <div className={s.root}>
    <div className={s.container}>
      <ContactForm reCaptcha={reCaptcha} />
    </div>
  </div>
);

Contact.propTypes = {
  reCaptcha: PropTypes.any
};

export default withStyles(s)(Contact);
